// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Marketplace Vendor Insights (VENDOR-INSIGHTS)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacevendorinsights.html
 *
 * 2025-02-24T21:48:53.435Z
 */
export enum AwsVendorInsightsActions {
  /**
   * Grants permission to activate the security profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  ActivateSecurityProfile = 'vendor-insights:ActivateSecurityProfile',
  /**
   * Grants permission to associate security profile with a data source
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  AssociateDataSource = 'vendor-insights:AssociateDataSource',
  /**
   * Grants permission to create a new data source
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  CreateDataSource = 'vendor-insights:CreateDataSource',
  /**
   * Grants permission to create a new security profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  CreateSecurityProfile = 'vendor-insights:CreateSecurityProfile',
  /**
   * Grants permission to deactivate the security profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  DeactivateSecurityProfile = 'vendor-insights:DeactivateSecurityProfile',
  /**
   * Grants permission to delete a data source
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  DeleteDataSource = 'vendor-insights:DeleteDataSource',
  /**
   * Grants permission to disassociate security profile from a data source
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  DisassociateDataSource = 'vendor-insights:DisassociateDataSource',
  /**
   * Grants permission to retrieve the details of an existing data source
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  GetDataSource = 'vendor-insights:GetDataSource',
  /**
   * Grants permission to return the details of a security profile snapshot that req
   * uester is entitled to read
   *
   * See https://docs.aws.amazon.com/marketplace/latest/buyerguide/buyer-vendor-insights-controlling-access.html
   */
  GetEntitledSecurityProfileSnapshot = 'vendor-insights:GetEntitledSecurityProfileSnapshot',
  /**
   * Grants permission to get the access terms for a vendor insights profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/buyerguide/buyer-vendor-insights-controlling-access.html
   */
  GetProfileAccessTerms = 'vendor-insights:GetProfileAccessTerms',
  /**
   * Grants permission to return the details of an existing security profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  GetSecurityProfile = 'vendor-insights:GetSecurityProfile',
  /**
   * Grants permission to return the details of a security profile snapshot
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  GetSecurityProfileSnapshot = 'vendor-insights:GetSecurityProfileSnapshot',
  /**
   * Grants permission to list existing data sources
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  ListDataSources = 'vendor-insights:ListDataSources',
  /**
   * Grants permission to return the snapshot summary list for an existing security
   * profile that requester is entitled to list
   *
   * See https://docs.aws.amazon.com/marketplace/latest/buyerguide/buyer-vendor-insights-controlling-access.html
   */
  ListEntitledSecurityProfileSnapshots = 'vendor-insights:ListEntitledSecurityProfileSnapshots',
  /**
   * Grants permission to list entitled security profiles
   *
   * See https://docs.aws.amazon.com/marketplace/latest/buyerguide/buyer-vendor-insights-controlling-access.html
   */
  ListEntitledSecurityProfiles = 'vendor-insights:ListEntitledSecurityProfiles',
  /**
   * Grants permission to return the snapshot summary list for an existing security
   * profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  ListSecurityProfileSnapshots = 'vendor-insights:ListSecurityProfileSnapshots',
  /**
   * Grants permission to list existing security profiles
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  ListSecurityProfiles = 'vendor-insights:ListSecurityProfiles',
  /**
   * Grants permission to list tags for vendor insights resource
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  ListTagsForResource = 'vendor-insights:ListTagsForResource',
  /**
   * Grants permission to tag vendor insights resource
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  TagResource = 'vendor-insights:TagResource',
  /**
   * Grants permission to untag vendor insights resource
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  UntagResource = 'vendor-insights:UntagResource',
  /**
   * Grants permission to update an existing data source
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  UpdateDataSource = 'vendor-insights:UpdateDataSource',
  /**
   * Grants permission to update the security profile
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  UpdateSecurityProfile = 'vendor-insights:UpdateSecurityProfile',
  /**
   * Grants permission to update the security profile snapshot creation configuratio
   * n
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  UpdateSecurityProfileSnapshotCreationConfiguration = 'vendor-insights:UpdateSecurityProfileSnapshotCreationConfiguration',
  /**
   * Grants permission to update the security profile snapshot release configuration
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/vendor-insights-seller-controlling-access.html
   */
  UpdateSecurityProfileSnapshotReleaseConfiguration = 'vendor-insights:UpdateSecurityProfileSnapshotReleaseConfiguration',
}
